import { useState, Dispatch, SetStateAction, useEffect } from "react";
import XoroWhite from "../../assects/img/XORO-White-1080 (4).png"
import Alert from "../../components/Alert";
import { useAuth } from "../../hooks/AuthContext";
import { fetchOliLogin } from "../../services/apiService";
import { useNavigate } from "react-router-dom";
import xoroLogo from "../../assects/img/X_logo.png";
interface OliProps {
    isOliAuthenticated: boolean;
}

const OliLogin: React.FC<OliProps> = ({ isOliAuthenticated }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({ email: "", password: "" });
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('isOliLoggedIn') === 'true') {
            navigate("/OliProducts");
        }
    }, []);

    function validate() {
        const next = { email: "", password: "" };
        const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
        if (!email.trim()) next.email = "Email is required";
        else if (!emailOk) next.email = "Enter a valid email";

        if (!password) next.password = "Password is required";

        setErrors(next);
        return !next.email && !next.password;
    }

    const { oliLogin } = useAuth();

    async function onSubmit(e:any) {
        e.preventDefault();
        if (!validate()) return;
        setLoading(true);
        try {
            const result = await fetchOliLogin(String(email), String(password));
            if(result.message == 'Account subscription expired'){
                setIsError(true);
                setError('Account subscription expired');
            }
            else if(result.message == 'User Expired'){
                setIsError(true);
                setError('User Expired');
            }
            else{
                localStorage.setItem('OliToken', result.token);
                localStorage.setItem('oli_account_id', result.account_id);
                localStorage.setItem('oli_role', result.role);
                localStorage.setItem('oli_username', result.name);
                localStorage.setItem('oli_id', result.id);
                oliLogin();
                navigate(`/OliConfigurator`);
            }
        } catch (error) {
            setIsError(true);
            if (error instanceof Error) {
                if(error.message === 'Request failed with status code 401'){
                    setError('Email or password wrong');
                }
                else{
                    setError(error.message);
                }
                
            } else {
                setError("An unexpected error occurred");
            }
        } finally {
        setLoading(false);
        }
    }

    const handleDismiss = (alertId: string) => {
        const alertElement = document.getElementById(alertId);
        if (alertElement) {
            setIsError(false);
            alertElement.style.display = 'none';
        }
    };
return (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/20">
    {/* Alert */}
    {isError && (
      <Alert
        id="alert-2"
        color="red"
        iconColor="text-red-800 dark:text-red-400"
        textColor="text-red-800 dark:text-red-400"
        bgColor="bg-red-50 dark:bg-gray-800"
        onDismiss={() => handleDismiss('alert-2')}
      >
        {(error !== null && error !== "") ? error : "Some error happen"}
      </Alert>
    )}

    {/* Main Container */}
    <div className="flex min-h-screen items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        
        {/* Header Section */}
      {/* Header Section */}
<div className="text-center">
  <div className="flex justify-center mb-6">
    <div className="relative">
      <div className="p-3 bg-white rounded-2xl shadow-lg border border-gray-200/50">
        <img
          src={xoroLogo}
          alt="XORO Logo"
          className="w-12 h-12 object-contain"
        />
      </div>
      <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-emerald-500 rounded-full border-2 border-white flex items-center justify-center">
        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
        </svg>
      </div>
    </div>
  </div>
  
  <div className="space-y-3">
    <h2 className="text-3xl font-bold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-700 bg-clip-text text-transparent">
      OLI
    </h2>
    <div className="flex items-center justify-center space-x-2 text-sm">
      <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
      <span className="text-gray-400"> Powered by XORO Story</span>
    </div>
    <p className="text-gray-500 font-medium">
      Welcome back — sign in to continue
    </p>
    
  </div>
</div>

        {/* Login Form */}
        <div className="relative">
          {/* Background Pattern */}
          <div className="absolute inset-0 bg-gradient-to-r from-blue-50/50 to-indigo-50/50 rounded-2xl transform rotate-1"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-indigo-50/50 to-purple-50/50 rounded-2xl transform -rotate-1"></div>
          
          {/* Form Container */}
          <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl border border-gray-200/60 p-8 shadow-xl">
            <form onSubmit={onSubmit} className="space-y-6" noValidate>
              
              {/* Email Field */}
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                  Email Address
                </label>
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                    </svg>
                  </div>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className={`block w-full pl-10 pr-4 py-3 border rounded-xl leading-5 bg-white/80 backdrop-blur-sm placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm hover:shadow-md ${
                      errors.email ? "border-red-300 ring-red-500/20" : "border-gray-300"
                    }`}
                  />
                </div>
                {errors.email && (
                  <p className="mt-2 text-sm text-red-600 flex items-center space-x-1">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    <span>{errors.email}</span>
                  </p>
                )}
              </div>

              {/* Password Field */}
              <div>
                <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-2">
                  Password
                </label>
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    className={`block w-full pl-10 pr-12 py-3 border rounded-xl leading-5 bg-white/80 backdrop-blur-sm placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm hover:shadow-md ${
                      errors.password ? "border-red-300 ring-red-500/20" : "border-gray-300"
                    }`}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((s) => !s)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors duration-200"
                  >
                    {showPassword ? (
                      <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                      </svg>
                    ) : (
                      <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    )}
                  </button>
                </div>
                {errors.password && (
                  <p className="mt-2 text-sm text-red-600 flex items-center space-x-1">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    <span>{errors.password}</span>
                  </p>
                )}
              </div>

              {/* Login Button */}
           <button
  type="submit"
  disabled={loading}
  className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-semibold rounded-xl text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
>
  <span className="absolute left-0 inset-y-0 flex items-center pl-3">
   
  </span>
  {loading ? "Signing in..." : "Sign In to OLI"}
</button>
            </form>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center space-x-4 text-xs text-gray-400">
            <div className="flex items-center space-x-1">
              <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full"></div>
              <span>Secure Login</span>
            </div>
            <div className="w-1 h-4 bg-gray-300 rounded-full"></div>
            <div className="flex items-center space-x-1">
              <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
              <span>Enterprise Grade</span>
            </div>
          </div>
          
          <p className="text-xs text-gray-500 leading-relaxed">
            By signing in, you agree to our{" "}
            <a href="#" className="text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200">
              Terms of Service
            </a>{" "}
            and{" "}
            <a href="#" className="text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200">
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
);
 
}

export default OliLogin;
